import React, { useEffect, useState } from "react";
import { latestFiveCryptoPrices } from "../services/apiService";

const AIInsights = () => {
    const [insights, setInsights] = useState([]);
    const [tick, setTick] = useState(0); // for rolling animation

    useEffect(() => {
        const fetchData = async () => {
            const tokens = ["ETH-USD", "SOL-USD", "PEPE-USD"]; // You can add more

            try {
                const results = await Promise.all(
                    tokens.map(async (token) => {
                        const data = await latestFiveCryptoPrices(token);
                        if (!data || data.length === 0) return null;

                        return {
                            token: token.split("-")[0],
                            summary: "AI-generated summary coming soon.",
                            confidence: Math.floor(Math.random() * 21) + 60,
                            prediction: data.map((d) => d.predicted_price),
                            time: data.map((d) => d.gmt_time),
                        };
                    })
                );

                // Filter out any failed fetches
                const validData = results.filter((item) => item !== null);
                if (validData.length > 0) {
                    setInsights(validData);
                } else {
                    throw new Error("No valid data");
                }
                setInsights(validData);
            } catch (error) {
                // fallback to dummy if needed
                setInsights([
                    {
                        token: "ETH",
                        summary: "AI predicts upward trend based on volume spikes.",
                        confidence: 87,
                        prediction: [1800, 1850, 1880, 1900, 1950, 2000],
                    },
                    {
                        token: "SOL",
                        summary: "Potential reversal flagged by volatility model.",
                        confidence: 72,
                        prediction: [90, 92, 88, 86, 89, 91],
                    },
                    {
                        token: "PEPE",
                        summary: "Social sentiment is driving short-term momentum.",
                        confidence: 64,
                        prediction: [0.0009, 0.0011, 0.0010, 0.0012, 0.0014, 0.0013],
                    },
                ]);
            }
        };

        fetchData();
    }, []);


    useEffect(() => {
        const interval = setInterval(() => {
            setTick((prev) => prev + 1);
        }, 2000); // every 2 seconds

        return () => clearInterval(interval);
    }, []);

    return (
        <section className="text-white">
            <h2 className="text-2xl font-bold text-indigo-400 mb-4">AI Insights</h2>
            <div className="space-y-4">
                {insights.map((item, index) => {
                    const imgPath = `/images/${item.token}.png`;
                    const prediction = item.prediction || [];
                    const i = tick % (prediction.length - 1); // cycle safely through array

                    const currentPrice = prediction[i];
                    const nextPrice = prediction[i + 1];

                    const priceChange =
                        nextPrice && currentPrice
                            ? ((nextPrice - currentPrice) / currentPrice) * 100
                            : null;

                    const priceColor =
                        priceChange > 0
                            ? "text-green-400"
                            : priceChange < 0
                                ? "text-red-400"
                                : "text-gray-300";

                    return (
                        <div
                            key={index}
                            className="bg-white/5 border border-indigo-500 rounded-xl p-4 flex items-center gap-4 transition-all duration-500 ease-in-out"
                        >
                            <img
                                src={imgPath}
                                alt={item.token}
                                className="w-12 h-12 rounded-full border border-white/20 bg-white/10 object-contain"
                                onError={(e) => (e.target.style.display = "none")}
                            />
                            <div className="flex-1">
                                <h3 className="text-md font-semibold text-indigo-300">{item.token}</h3>
                                <p className="text-sm text-gray-300">{item.summary}</p>
                                <p className="text-sm text-indigo-200">Confidence: {item.confidence}%</p>
                                {currentPrice && nextPrice && (
                                    <div className="text-sm mt-2 transition-all duration-500 ease-in-out">
                                        <p className="text-gray-400">
                                            Price Now: <span className="text-white">${currentPrice.toFixed(4)}</span>
                                        </p>
                                        <p className="text-gray-400">
                                            Next Predicted: <span className="text-white">${nextPrice.toFixed(4)}</span>
                                        </p>
                                        <p className="text-gray-400">
                                            Change:{" "}
                                            <span className={`font-semibold ${priceColor}`}>
                                                {priceChange >= 0 ? "+" : ""}
                                                {priceChange?.toFixed(2)}%
                                            </span>
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </section>
    );
};

export default AIInsights;
